import { Pagination as PaginationBar } from 'antd';
import { useTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import {
	ApplicationSummary,
	PagingConfig,
} from '../../../shared/VolunteerApplicationServiceTypes';
import { ApplicationSummaryCard } from './ApplicationSummaryCard';
import { ApplicationSummaryTable } from './ApplicationSummaryTable';
import { DEFAULT_PAGE_SIZE } from '../../../shared/Constants';
import { PreworkApplicationsResponse } from '../../../shared/PreWorkServiceTypes';
import EmptyList from '../../../components/EmptyList';

interface ApplicationsListProps {
	data: PreworkApplicationsResponse;
	onPageChange: (page: number, pageSize: number) => void;
	onEvaluateClick: (application: ApplicationSummary) => void;
	pageConfig: PagingConfig;
}

export const ApplicationsList = ({
	data: { preworkStatus: applications, pagination },
	onPageChange,
	onEvaluateClick,
	pageConfig,
}: ApplicationsListProps) => {
	const { t } = useTranslation();
	if (
		isEmpty(pagination.totalNoOfRecords) ||
		pagination.totalNoOfRecords === 0
	) {
		return <EmptyList message={t('noApplications')} />;
	}

	const applicationCards = applications?.map((application) => (
		<div className="mb-[16px]" key={application.applicationId}>
			<ApplicationSummaryCard
				{...application}
				onEvaluateClick={onEvaluateClick}
			/>{' '}
		</div>
	));

	return (
		<div className="flex flex-col gap-6">
			<div className="sm:hidden">
				{applicationCards}
				<div className="flex justify-center w-full">
					<PaginationBar
						current={pageConfig.pageNo ?? 1}
						total={pagination.totalNoOfRecords}
						defaultPageSize={pageConfig.pageSize ?? DEFAULT_PAGE_SIZE}
						onChange={onPageChange}
					/>
				</div>
			</div>
			<div className="hidden sm:block">
				<ApplicationSummaryTable
					applications={applications}
					onEvaluateClick={onEvaluateClick}
					pagination={pagination}
					onPageChange={onPageChange}
					pageConfig={pageConfig}
				/>
			</div>
		</div>
	);
};
